const StructuredContentDateType = {
  DOB: "dob",
  INTERACTION: "interaction",
  AUTOMATION_ANALYSIS_WINDOW: "automation_analysis_window",
  OTHER: "other"
};
const allStructuredContentDateTypes = [
  StructuredContentDateType.DOB,
  StructuredContentDateType.INTERACTION,
  StructuredContentDateType.AUTOMATION_ANALYSIS_WINDOW,
  StructuredContentDateType.OTHER
];
export {
  StructuredContentDateType,
  allStructuredContentDateTypes
};
//# sourceMappingURL=types.js.map
